import {Breadcrumb, Typography} from "antd";
import { Link, useLocation } from "react-router";
import { getPageMeta } from "../../data/admin";

const { Text, Title } = Typography;
export default function AdminTopbar() {
  const currentLocation = useLocation();
  const activeSection = getPageMeta(currentLocation.pathname);

  return (
    <header className="sticky top-0 z-20 border-b border-black/8 bg-white px-3 py-3 sm:px-4 md:px-6 lg:px-8 dark:border-white/8 dark:bg-dark flex justify-between items-end">
        <div>
            <Text className="block text-[11px]! uppercase tracking-[0.18em] text-black/45 dark:text-white/45">
                {activeSection.section}
            </Text>
            <Title level={5} className="mb-0! mt-1!">
                {activeSection.label}
            </Title>
        </div>
        <Breadcrumb
            items={[
                { title: <Link to="/overview">Admin</Link> },
                { title: activeSection.section },
                { title: activeSection.label },
            ]}
        />
    </header>
  );
}
